import { Box, Tab, Tabs } from "@mui/material";
import { useCurrentUser } from "hooks/useCurrentUser";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

type NotificationsTab = "inbox" | "test";

function tabFromPath(pathname: string): NotificationsTab {
  return pathname.endsWith("/test") ? "test" : "inbox";
}

export function NotificationsHub() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isStaff } = useCurrentUser();
  const activeTab = tabFromPath(location.pathname);

  const handleChange = (_event: React.SyntheticEvent, value: NotificationsTab) => {
    if (value === activeTab) {
      return;
    }
    if (value === "test") {
      navigate("test");
    } else {
      navigate(".");
    }
  };

  return (
    <Box>
      {isStaff ? (
        <Tabs
          value={activeTab}
          onChange={handleChange}
          sx={{ px: { xs: 2, md: 3 }, borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Notifications" value="inbox" />
          <Tab label="Test" value="test" />
        </Tabs>
      ) : null}
      <Outlet />
    </Box>
  );
}
